/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResponseForAgentActionForm extends models.BaseForAgentResponse {
    constructor() {
        super();
        this.setDiscriminator("ActionForm");
    }

    getFixupPrototypeFunction() { return ResponseForAgentActionForm.fixupPrototype; }

    static newInstance(model: Partial<ResponseForAgentActionForm>): ResponseForAgentActionForm {
        let obj = Object.assign(new ResponseForAgentActionForm(), model);
        ResponseForAgentActionForm.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResponseForAgentActionForm>): ResponseForAgentActionForm {
        if (!model) return null;
        return ResponseForAgentActionForm.newInstance(<ResponseForAgentActionForm> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResponseForAgentActionForm) {
        if (!obj) return;

        models.ResponseForAgentActionForm.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResponseForAgentActionForm): boolean {
        if (models.BaseForAgentResponse.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResponseForAgentActionForm.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.fields) {
            for (let val of this.fields) {
                models.ActionFormField.fixupPrototype(val);
            }
        }
        if (this.sections) {
            for (let val of this.sections) {
                models.ActionFormSection.fixupPrototype(val);
            }
        }
    }

    /**
     * PendingAction document ID
     */
    action_id: string;

    /**
     * Registered action form type key
     */
    form_type: string;

    /**
     * Form title shown in UI
     */
    title: string;

    /**
     * Short description shown below title
     */
    summary: string;

    /**
     * Destructive-action warning; null if safe
     */
    warning: string;

    /**
     * User-editable input fields
     */
    fields: Array<models.ActionFormField>;

    /**
     * Per-task status items (policy execute only)
     */
    task_list: Array<any>;

    /**
     * Visual groupings for fields
     */
    sections: Array<models.ActionFormSection>;

    /**
     * Pre-computed execution payload from build_form()
     */
    payload_preview: any;

}
